import { render } from "./About.vue?vue&type=template&id=64d572a7"
const script = {}
script.render = render

export default script